function parseBlob(value) {
    if (value == null) {
        return null;
    }
    try {
        return JSON.parse(value);
    }
    catch (_a) {
        return null;
    }
}
export function buildFuelPlansFromStoredRows(rows) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const plans = new Map();
    for (const row of rows) {
        if (row.kind !== 'event' || row.eventId == null || row.isActive !== 'x') {
            continue;
        }
        const ops = parseBlob(row.opsData);
        const meta = parseBlob(row.metaData);
        if (ops == null || meta == null) {
            continue;
        }
        const planFob = parseBlob(row.planData);
        plans.set(row.eventId, {
            plan: ops,
            converged: (_a = meta.converged) !== null && _a !== void 0 ? _a : true,
            fuelDataSource: (_b = meta.fuelDataSource) !== null && _b !== void 0 ? _b : 'computed',
            fobSource: (_c = meta.fobSource) !== null && _c !== void 0 ? _c : 'profile-reserve',
            fobSourceRowKey: (_d = meta.fobSourceRowKey) !== null && _d !== void 0 ? _d : undefined,
            flightDurationMinutes: (_e = meta.flightDurationMinutes) !== null && _e !== void 0 ? _e : undefined,
            mreqOfpComponents: (_f = meta.mreqOfpComponents) !== null && _f !== void 0 ? _f : undefined,
            planFob: planFob == null ? undefined : planFob,
            planFobSource: (_g = meta.planFobSource) !== null && _g !== void 0 ? _g : undefined,
            planFobSourceRowKey: (_h = meta.planFobSourceRowKey) !== null && _h !== void 0 ? _h : undefined,
        });
    }
    return plans;
}
export function storedLegUpliftForSnapshot(plan, frozenUplift) {
    var _a, _b;
    return (_b = (_a = plan === null || plan === void 0 ? void 0 : plan.plan) === null || _a === void 0 ? void 0 : _a.fuelUplift) !== null && _b !== void 0 ? _b : frozenUplift;
}
export function buildFuelPricesFromStoredRows(rows) {
    const prices = new Map();
    for (const row of rows) {
        if (row.id == null || row.isActive !== 'x') {
            continue;
        }
        const price = parseBlob(row.priceData);
        if (price != null) {
            prices.set(row.id, price);
        }
    }
    return prices;
}
//# sourceMappingURL=storedRowPlans.js.map